import Loadable from 'react-loadable';
import Loading from '../components/Loading';

const Menu = Loadable({
  loader: () => import('./Menu/Menu.js'),
  loading: Loading
})
const PersonSelMen = Loadable({
  loader: () => import('./PersonSelMen/PersonSelMen.js'),
  loading: Loading
})

const ShowAppointment = Loadable({
  loader: () => import('./ShowAppointment/ShowAppointment.js'),
  loading: Loading
})
const PersonCardPointment = Loadable({
  loader: () => import('./PersonCardPointment/PersonCardPointment.js'),
  loading: Loading
})
const Agreement = Loadable({
  loader: () => import('./Agreement/Agreement.js'),
  loading: Loading
})
const AgreementTeam = Loadable({
  loader: () => import('./AgreementTeam/AgreementTeam.js'),
  loading: Loading
})


const PersonAppointment = Loadable({
  loader: () => import('./PersonAppointment/PersonAppointment.js'),
  loading: Loading
})

const TeamAppointment = Loadable({
  loader: () => import('./TeamAppointment/TeamAppointment.js'),
  loading: Loading
})

const ReservationRecord = Loadable({
  loader: () => import('./ReservationRecord/ReservationRecord.js'),
  loading: Loading
})

const LogoTeam = Loadable({
  loader: () => import('./LogoTeam/LogoTeam.js'),
  loading: Loading
})

const RegisteredTeam = Loadable({
  loader: () => import('./RegisteredTeam/RegisteredTeam.js'),
  loading: Loading
})
const ShowTeamAppointment = Loadable({
  loader: () => import('./ShowTeamAppointment/ShowTeamAppointment.js'),
  loading: Loading
})
const ShowAppointmentFaild = Loadable({
  loader: () => import('./ShowAppointmentFaild/ShowAppointmentFaild.js'),
  loading: Loading
})
const ViewLogin = Loadable({
  loader: () => import('./ViewLogin/ViewLogin.js'),
  loading: Loading
})
export {
  Menu,
  PersonSelMen,
  ShowAppointment,
  Agreement,
  AgreementTeam,
  PersonAppointment,
  PersonCardPointment,
  TeamAppointment,
  ReservationRecord,
  LogoTeam,
  RegisteredTeam,
  ShowTeamAppointment,
  ShowAppointmentFaild,
  ViewLogin
}
